<template>
<div class="index-header-wrap">
  <div class="logo">
    <img src="~@/assets/image/logo-black.png" alt="logo" class="logo">
  </div>
  <div class="header-option-icon">
    <!-- <svg id="homepageQQ" @click="qqContact" class="icon" style="font-size:32px;cursor: pointer;margin-top:2px;width: 50px;" aria-hidden="true" v-if="userRole != '1'">
      <use xlink:href="#icon-QQkefu-icon"></use>
    </svg> -->
    <a href="javascript:void(0);" @click="showTaskPage()" v-if="userRole == '1'">
      <i class="iconfont icon-shangchuan"></i>
    </a>
    <a href="javascript:void(0);" @click="showTaskPage()" v-else>
      <i class="iconfont icon-shangchuan"></i>
    </a>
    <el-tooltip content="联系我们" placement="bottom" effect="light">
      <a href="javascript:void(0);" @click="showQrCode()" v-if="userInfo.organization.costType == '0' && ['2', '3', '4'].includes(userRole)">
        <i class="el-icon-service"></i>
      </a>
    </el-tooltip>
    <!-- <kw-helper></kw-helper> -->
    <school-user-position
      v-if="isSchoolRole"
      ref="schoolUserPosition">
    </school-user-position>
    <i @click="logout" class="iconfont icon-guanbi4"></i>
    <transition name="qr-fade">
      <div class="service-qrcode-pic" v-show="qrCodeVis" v-clickoutside="hideQrCode">
        <i class="el-icon-close" @click="hideQrCode"></i>
        <img :src="customerServiceQR" alt="">
      </div>
    </transition>
  </div>
</div>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import { logout } from '@/model/info-model'
import customerServiceQR from '@/assets/image/customerServiceQR.png'
import common from '@/util/common'
import KwHelper from '@/components/custom/KwHelper'
import SchoolUserPosition from '@/components/custom/SchoolUserPosition'

export default {
  name: 'Header',
  directives: {
    Clickoutside
  },
  data () {
    return {
      tipVisible: false,
      userRole: null,
      positionCloseAble: false,
      positionVisible: false,
      qrCodeVis: false,
      customerServiceQR
    }
  },
  components: {
    KwHelper,
    SchoolUserPosition
  },
  computed: {
    roleType () {
      return common.systemRoleEnum
    },
    userInfo () {
      return common.getUserInfo()
    },
    isSchoolRole () {
      let check = false
      // 先判断系统角色
      if (this.userRole === this.roleType.teacher) {
        check = true
      }
      return check
    }
  },
  methods: {
    showTaskPage () {
      let url = '/task'
      if (this.userRole === '1') {
        url = '/adminTask'
      }
      window.open(url)
    },
    showQrCode () {
      // this.qrCodeVis = true
      // window.open('https://work.weixin.qq.com/kfid/kfca284d1a02ae9d816')
      window.open('https://work.weixin.qq.com/kfid/kfc234aa643d94bba75')
    },
    hideQrCode () {
      if (this.qrCodeVis) {
        this.qrCodeVis = false
      }
    },
    qqContact () {
      console.log('qqContact')
    },
    clearLoginInfo () {
      let searchUserId = location.search.split('userId=')[1] ? { userId: location.search.split('userId=')[1].split('&')[0] } : null
      let userInfo = JSON.parse(sessionStorage.getItem('user_info')) || searchUserId || (top.GLOBAL ? top.GLOBAL.user : null) || {}
      sessionStorage.removeItem('login_validate_id')
      localStorage.removeItem(`kw_token-${userInfo.userId}`)
      localStorage.removeItem('kw_refresh_token')
    },
    logout () {
      logout().then(res => {
        this.clearLoginInfo()
        window.location.href = '/index.html'
        // this.$router.push('/index.html')
      }).catch(err => {
        console.log(err)
        this.clearLoginInfo()
        window.location.href = '/index.html'
      })
    }
  },
  mounted () {
    console.log('IndexHeaderMounted')
    this.userRole = common.getUserInfo().role
    if (process.env.NODE_ENV === 'production') {
    // 加载调起qq咨询方法JS
      let scriptDom = document.createElement('script')
      scriptDom.id = 'qd2852151183b72f3db1686fc0d81d221f8e98165590'
      scriptDom.src = 'https://wp.qiye.qq.com/qidian/2852151183/b72f3db1686fc0d81d221f8e98165590'
      scriptDom.setAttribute('async', 'async')
      scriptDom.setAttribute('defer', 'defer')
      document.getElementsByTagName('body')[0].appendChild(scriptDom)
    }
    // 加载字体js加载文件
    let scriptFont = document.createElement('script')
    scriptFont.id = 'font-js'
    scriptFont.src = '//at.alicdn.com/t/font_448110_uo242a43koa.js'
    document.getElementsByTagName('body')[0].appendChild(scriptFont)
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.index-header-wrap{
  width: 100%;
  height: 60px;
  background: #ecebe6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .logo{
    display: inline-block;
    img{
      width: auto;
      height: 60px;
    }
  }
  .header-option-icon{
    height: 60px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    a{
      text-decoration: none;
    }
    i{
      font-size: 28px;
      display: inline-block;
      color: #333;
      margin: 15px;
      cursor: pointer;
    }
    .icon-guanbi4{
      font-size: 24px;
    }
  }
  .service-qrcode-pic{
    position: fixed;
    top: 60px;
    right: 20px;
    width: 275px;
    img{
      display: block;
      width: 100%;
      user-select: none;
      -webkit-user-drag: none;
    }
    .el-icon-close{
      position: absolute;
      right: 0;
      cursor: pointer;
      margin: 0;
      padding: 15px;
    }
  }
}
.qr-fade-enter-active, .qr-fade-leave-active {
  transition: opacity .2s;
}
.qr-fade-enter, .qr-fade-leave-to{
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/home/IndexHeader.vue